import { render, staticRenderFns } from "./vehicle-cross-selling-slider.vue?vue&type=template&id=5c4657ff&"
import script from "./vehicle-cross-selling-slider.vue?vue&type=script&lang=js&"
export * from "./vehicle-cross-selling-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports